import { createContext, useCallback, useContext, useState } from "react";

export const ShowFieldErrorsContext = createContext(false);

const isEmptyValue = (value: unknown): boolean =>
  Array.isArray(value) ? !value.length : !String(value ?? "").trim();

export const getFieldErrorId = (fieldId: string) => `${fieldId}-error`;

export const useRequiredFieldError = (value: unknown, required: boolean, forceShow = false) => {
  const showAllErrors = useContext(ShowFieldErrorsContext);
  const [isTouched, setIsTouched] = useState(false);
  const handleBlur = useCallback(() => setIsTouched(true), []);

  const showErrors = isTouched || showAllErrors || forceShow;

  return {
    hasError: required && showErrors && isEmptyValue(value),
    showErrors,
    handleBlur,
  };
};
